import { render } from "./ReportCriterionAutocomplete.vue?vue&type=template&id=4b09b151&scoped=true"
import script from "./ReportCriterionAutocomplete.vue?vue&type=script&lang=js"
export * from "./ReportCriterionAutocomplete.vue?vue&type=script&lang=js"

import "./ReportCriterionAutocomplete.vue?vue&type=style&index=0&id=4b09b151&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b09b151"]])

export default __exports__